// store global types
import type { TCreateSlice } from "@/store";

type TActionsPublicEditExtractionRows = {
    setSelectedRows: (rowIds: number[]) => void;
    setSelectedColumns: (columnIds: number[]) => void;
    setEditMode: (editMode: "off" | "rows" | "columns") => void;
};

export type TStateEditExtractionRows = {
    selectedRows: number[];
    selectedColumns: number[];
    editMode: "off" | "rows" | "columns";
};

export type TSliceEditExtractionRows = TStateEditExtractionRows &
    TActionsPublicEditExtractionRows;

export const initialStateEditExtractionRows = {
    selectedRows: [],
    selectedColumns: [],
    editMode: "off",
} as const satisfies TStateEditExtractionRows;

export const createSliceEditExtractionRows: TCreateSlice<
    TSliceEditExtractionRows,
    Record<string, never>
> = () => (set, getState) => ({
    ...initialStateEditExtractionRows,
    setSelectedRows: (rowIds: number[]) => {
        set(state => ({
            ...state,
            selectedRows: rowIds,
        }));
    },
    setSelectedColumns: (columnIds: number[]) => {
        set(state => ({
            ...state,
            selectedColumns: columnIds,
        }));
    },
    setEditMode: (editMode: "off" | "rows" | "columns") => {
        if (editMode === getState().editMode) return;
        set({
            editMode,
            selectedColumns: [],
            selectedRows: [],
        });
    },
});
